// @mui material components
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import { Link } from 'react-router-dom';

// Material Kit 2 React components
import MKBox from 'components/MKBox';
import MKButton from 'components/MKButton';
import MKTypography from 'components/MKTypography';

function EventsHeader() {
  return (
    <MKBox mb={5} bgColor='warning'>
      <MKBox py={10} display='flex' alignItems='center' minHeight='100%'>
        <Container>
          <Grid
            container
            item
            xs={12}
            md={7}
            lg={6}
            flexDirection='column'
            justifyContent='center'
          >
            <MKTypography
              variant='h1'
              textGradient
              mb={3}
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down('md')]: {
                  fontSize: size['3xl'],
                },
              })}
            >
              Events
            </MKTypography>
            <MKTypography variant='body1' color='light' pr={6} mr={6}>
              Catch up with all our latest events and programs
            </MKTypography>
            <Stack direction='row' spacing={1} mt={3}>
              <MKButton component={Link} to='/contact-us' color='white'>
                Become a member
              </MKButton>
              <MKButton
                component={Link}
                to='/gallery'
                variant='text'
                color='white'
              >
                Visit Gallery
              </MKButton>
            </Stack>
          </Grid>
        </Container>
      </MKBox>
    </MKBox>
  );
}

export default EventsHeader;
